import { render, staticRenderFns } from "./jde.vue?vue&type=template&id=2238be7c"
import script from "./jde.vue?vue&type=script&lang=js"
export * from "./jde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports